// http://hackingui.com/front-end/a-pure-css-solution-for-multiline-text-truncation/

import Typography from '@mui/material/Typography';
import React from 'react';

const Excerpt = props => {
  const { title, text } = props;
  return (
    <>
      {title && (
        <Typography
          color="textPrimary"
          gutterBottom
          variant="h6"
          component="h2"
          className="preview-title tw-font-bold"
        >
          {title}
        </Typography>
      )}
      {text && (
        <Typography
          component="p"
          color="textSecondary"
          className="preview-text"
        >
          {text
            .replace(/&amp;/g, '&')
            .replace(/!([a-zA-Z])/g, '! $1')
            .substring(0, 300)}
        </Typography>
      )}
      <style jsx global>{`
        .preview-title {
          line-height: 1.3em;
          max-height: 3.9em;
          overflow: hidden;
          position: relative;
        }
        .preview-text {
          line-height: 1.5em;
          max-height: 4.5em;
          overflow: hidden;
          position: relative;
          text-align: justify;
        }
      `}</style>
    </>
  );
};

export default Excerpt;
